import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const SetCardLocked = gql`
  mutation SetCardLocked(
    $idempotencyId: String!
    $cardId: ID!
    $locked: Boolean!
  ) {
    setCardLocked(
      idempotencyId: $idempotencyId
      input: { cardId: $cardId, locked: $locked }
    ) {
      ... on SetCardLockedSuccess {
        id
        updated
        card {
          id
          isLocked
          status
          __typename
        }
        __typename
      }
      ... on SetCardLockedFailure {
        ...error
        __typename
      }
      __typename
    }
  }
  ${error}
`;
export default SetCardLocked;
